import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rr-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
})
export class TagComponent implements OnInit {
  @Input() tag: { colour: string; name: string; value: string | null };

  constructor() {}

  ngOnInit(): void {}
}
